import { computed, onBeforeUnmount, ref } from 'vue';

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const useTableData = (params) => {
    const { load, debounceMs, retry, refreshCooldownMs } = params;

    const isRefreshing = ref(false);
    const refreshBlockedUntil = ref(0);
    const refreshRemainingMs = computed(() => {
        const now = Date.now();
        return Math.max(0, refreshBlockedUntil.value - now);
    });

    let debounceTimer = null;
    onBeforeUnmount(() => {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = null;
    });
    const runLoad = async () => {
        if (typeof load !== 'function') return;
        let attempts = Math.max(0, Number(retry.value || 0));
        while (true) {
            try {
                return await Promise.resolve(load());
            }
            catch (e) {
                if (attempts <= 0) throw e;
                attempts -= 1;
                await delay(300);
            }
        }
    };

    const debouncedLoad = () => {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            runLoad();
        }, Math.max(0, Number(debounceMs.value || 0)));
    };

    const refresh = async () => {
        const now = Date.now();
        if (now < refreshBlockedUntil.value) return;
        refreshBlockedUntil.value = now + Math.max(0, Number(refreshCooldownMs.value || 0));
        isRefreshing.value = true;
        try {
            await runLoad();
        }
        finally {
            isRefreshing.value = false;
        }
    };

    return {
        debouncedLoad,
        refresh,
        isRefreshing,
        refreshRemainingMs
    };
};
